import axios from 'axios'
const CancelToken = axios.CancelToken
let source

export default {
    getCount: async function(condition, cb) {
        if (source) {
            source.cancel()
        }
        source = CancelToken.source()
        await axios.post('/api/item/count', condition, {
            cancelToken: source.token
        })
        .then(cb)
        .catch(error => {
            console.log(error)
        })
    }
}
